export default {
    isSso: false,

    setIsSso(isSso: boolean) {
        this.isSso = isSso;
    },

    getIsSso():boolean {
        return this.isSso;
    }
}